import axios from 'axios';

export default {
    async list({ page, search, orderby }) {
        if (!page)
            page = 1;

        let response = await axios.get('/api/customers', { params: { page, search, orderby } });
        return response.data;
    },
    async get(id) {
        id = parseInt(id);
        let response = await axios.get(`/api/customers/${id}`);
        return response.data;
    },
    async search(term) {
        let response = await axios.get('/api/customers/search', { params: { term } });
        return response.data;
    },
    async create(customer) {
        customer = await axios.post('/api/customers', customer);
        return customer.data;
    },
    async update(customer) {
        customer = await axios.patch(`/api/customers/${customer.id}`, customer);
        return customer.data;
    },
    async readMessages(customer) {
        customer = await axios.post(`/api/customers/${customer.id}/readMessages`);
        return customer.data;
    },
    async delete(customer) {
        let response = await axios.delete(`/api/customers/${customer.id}`);
        return response.data;
    },
};
